import * as blocLiensStyles from '../../../styles/admissions/admissions.module.scss';
import {getDate, getHour} from '../../../utils/parsing';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import React from 'react';
import SpecialLink from './SpecialLink';
import clsx from 'clsx';
import {getI18n, useTranslation} from 'react-i18next';

const EventInfo = ({event, color}) => {
  const i18n = getI18n();
  const getLanguage = () => i18n.language;
  const {t} = useTranslation();


  if (!event) {
    return null;
  }

  const getEventLocationByLanguage = () => {
    const lng = getLanguage();
    if (event?.event_location) {
      const el = event.event_location;
      if(el.localizations && el.localizations.length === 1 && el.localizations[0].locale=== lng) {
        return el.localizations[0];
      }
      return el;
    }
    return null;
  };


  const start_day = getDate(event.start_date, ' ', {month: 'long'}, getLanguage());
  const end_day = getDate(event.end_date, ' ', {month: 'long'}, getLanguage());
  const start_hour = getHour(event.start_date);
  const end_hour = getHour(event.end_date);
  let title1 = '';
  let title2 = '';

  const evtLoc = getEventLocationByLanguage();

  if (evtLoc) {
    if (evtLoc.room) {
      title1 = `${evtLoc.room}`;
    }
    if (evtLoc.event_address) {
      const ea = evtLoc.event_address;
      const addr = [];
      for (const key of ['address', 'zip', 'city', 'country']) {
        if (ea[key]) {
          addr.push(ea[key]);
        }
      }
      title2 = addr.join(', ');
    }
  }
  if (event.event_location?.event_address) {
    const ea = event.event_location.event_address;
    const addr = [];
    for (const key of ['address', 'zip', 'city', 'country']) {
      if (ea[key]) {
        addr.push(ea[key]);
      }
    }
    title2 = addr.join(', ');
  }

  return (
    <>
      <div
        className={clsx(
          blocLiensStyles.contentTitleInfo, {
            [blocLiensStyles.darkBlocLiensEntete]: color === 'BLACK',
            [blocLiensStyles.redBlocLiensEntete]: color !== 'BLACK'
          })
        }
      >
        <div className={blocLiensStyles.itemTitleInfo}>
          <h2 className={blocLiensStyles.relatedTitleEventInfo}>
            {t('event.page.widget')}
          </h2>
        </div>
      </div>
      <div
        className={clsx(
          blocLiensStyles.contentTitleInfo, {
            [blocLiensStyles.darkActionListCorps]: color === 'BLACK',
            [blocLiensStyles.redActionListCorps]: color !== 'BLACK'
          })
        }
      >
        {
          <div className={clsx(blocLiensStyles.margin, blocLiensStyles.specialLinkEventInfo)}>
            <SpecialLink arrowDisable
              color="#706f6f"
              disable
              icon={
                <IconContainer
                  color={color}
                  icon="CALENDAR"
                  size={25}
                  style={{padding: '5px'}}
                  svgClassname={blocLiensStyles.actionSvgIcon}
                  variant="outlined"
                />
              }
              isEventInfo
              lowcase
              suppressHydrationWarning
              textTransform="none"
              title={
                start_day !== end_day
                  ? t('event.page.date.several.days', {
                    start_day: start_day,
                    start_hour: start_hour,
                    end_day: end_day,
                    end_hour: end_hour,
                  })
                  : t('event.page.date.single.day', {
                    start_day: start_day,
                    start_hour: start_hour,
                    end_hour: end_hour,
                  })
              }
            />
          </div>
        }
        {event?.event_location && (
          <>
            <div
              className={clsx(
                blocLiensStyles.separation,
                blocLiensStyles.margin,
              )}
            >
            </div>
            <div className={clsx(
              blocLiensStyles.margin,
              blocLiensStyles.specialLinkEventInfo)}
            >
              <SpecialLink
                arrowDisable
                color="#706f6f"
                disable
                icon={
                  <IconContainer
                    color={color}
                    icon="LOCATION"
                    size={25}
                    style={{padding: '5px'}}
                    svgClassname={blocLiensStyles.actionSvgIcon}
                    variant="outlined"
                  />
                }
                isEventInfo
                lowcase
                subtitle={title2}
                textTransform="none"
                title={title1}
              />
            </div>
          </>
        )}
        {event?.organizer && (
          <>
            <div
              className={clsx(
                blocLiensStyles.separation,
                blocLiensStyles.margin,
              )}
            >
            </div>
            <div>
              <SpecialLink
                arrowDisable
                color="#706f6f"
                disable
                icon={
                  <IconContainer
                    color={color}
                    icon="AWARD"
                    size={25}
                    style={{padding: '5px'}}
                    svgClassname={blocLiensStyles.actionSvgIcon}
                    variant="outlined"
                  />
                }
                isRelatedContent
                lowcase
                subtitle={event.organizer}
                textTransform="none"
                title={t('event.page.info.organized.by')}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

EventInfo.propTypes = {
  color: PropTypes.oneOf(['BLACK', 'RED']),
  event: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    event_location: PropTypes.shape({
      localizations: PropTypes.arrayOf(PropTypes.shape({
        locale: PropTypes.string,
      })),
      room: PropTypes.string,
      event_address: PropTypes.shape({
        address: PropTypes.string,
        zip: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
      }),
    }),
    organizer: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
};

export default EventInfo;
